import {isFeatureEnabled} from 'feature-flags';

import {Navigate} from 'react-router-dom';

import {warehouseRoutes} from '@dms/routes';

import {WAREHOUSE_CHART_TABS} from './warehouseChartTabs';

export function WarehouseChartUnavailable() {
  const hasAvailableChart = WAREHOUSE_CHART_TABS.some((chart) =>
    isFeatureEnabled(chart.featureFlag)
  );

  return (
    <Navigate
      replace
      to={hasAvailableChart ? warehouseRoutes.reportingCharts : warehouseRoutes.reporting}
    />
  );
}
